export const distinct = <TItem>(items: TItem[]): TItem[] => {
  return [...new Set(items)];
};
